import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AvatarEditor from "react-avatar-editor";
import Button from "@material-ui/core/Button";
import { Avatar, Modal } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { UpdateUserProfileImage } from "../../../user/UserActions";
import { GetRecommendProfessionalList } from "../../homePage/HomePageActions";
import { filterUserList } from "../../../presenters/PresentersActions";
import { AppState } from "../../../root/RootReducer";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { t } from "i18next";

interface EditProfileImageProps {
    userid: string | undefined;
    fullname: string | undefined;
    organization: string | undefined;
    localAccountId: string | undefined;
    // クリックコールバック関数
    onCallback?: any;
    // 親モーダル用コールバック関数
    onClose?: any;
}

export default function EditProfileImage({ ...props }: EditProfileImageProps) {
    const { userInfo } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
    }));

    const dispatch = useDispatch();
    const inputImageRef = useRef<HTMLInputElement>(null);

    // モーダルモード
    const [openPhotoModal, setOpenPhotoModal] = useState(false);
    // ユーザー画像関連
    const [profileImage, setProfileImage] = useState("");
    const [newImage, setNewImage] = useState<any>();
    const [newImageUrl, setNewImageUrl] = useState("");
    const [scale, setScale] = useState(1.5);

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };
    // プレビューモード
    const [preview, setPreview] = useState(false);
    // プロファイル画像状態
    const [fileName, setFileName] = useState("");
    const imageRef = useRef<AvatarEditor>(null);

    // 画像編集用モーダルを開く
    const OpenPhotoModal = (event: any) => {
        if (event.target.files.length >= 1) {
            if (event.target.files[0].size > 0) {
                setProfileImage(event.target.files[0]);
                if (userInfo) setFileName(userInfo.email);
                // setFileName(event.target.files[0].name);
                setOpenPhotoModal(true);
            } else {
                ChangeErrorInputSize(true);
                if (inputImageRef.current) {
                    inputImageRef.current.value = "";
                }
            }
        }
    };
    // 画像編集用モーダルを閉じる
    const ClosePhotoModal = () => {
        setOpenPhotoModal(false);
        if (props.onClose) props.onClose();
        if (inputImageRef.current) {
            inputImageRef.current.value = "";
        }
    };

    // ユーザー画像のトリミング
    const handleScale = (event: any) => {
        setScale(parseFloat(event.target.value));
    };

    // 画像プレビュー
    const [isLoadPreviewImage, LoadPreviewImage] = useState(false);
    const onClickPreview = () => {
        const image = imageRef.current?.getImage();
        image?.toBlob((blob: any) => {
            setNewImage(blob);
            setNewImageUrl(window.URL.createObjectURL(blob));
        });
        setPreview(true);
    };

    useEffect(() => {
        if (!newImage) {
            LoadPreviewImage(true);
        } else {
            LoadPreviewImage(false);
        }
    }, [newImage]);

    // キャンセル
    const onClickCancel = () => {
        setPreview(false);
    };

    // 画像保存
    const onClickSave = () => {
        if (props.onCallback) {
            // ユーザー管理画面用
            props.onCallback(props.userid, newImageUrl, new File([newImage], fileName));
        } else {
            // ログインユーザー用
            const file = new File([newImage], fileName);
            if (props.userid && props.fullname) {
                const userItem = {
                    id: props.userid,
                    fullName: props.fullname,
                    organization: props.organization,
                    localAccountId: props.localAccountId,
                    profileImageUrl: "",
                };
                dispatch(UpdateUserProfileImage(file, userItem));
                if (userInfo) {
                    // TEMP FIX
                    setTimeout(
                        () => dispatch(GetRecommendProfessionalList(parseInt(userInfo.id))),
                        2000
                    );
                    const userFilter = { id: parseInt(userInfo.id), skill: [], tag: [] };
                    setTimeout(() => dispatch(filterUserList(userFilter)), 2000);
                }
            }
        }
        // モーダルリセット
        setPreview(false);
        ClosePhotoModal();
        if (props.onClose) props.onClose();
    };

    return (
        <>
            <div>
                <label htmlFor={"newfile" + props.userid}>
                    <AddIcon
                        style={{
                            color: "white",
                            position: "absolute",
                            marginLeft: "-8px",
                            marginTop: "31px",
                            cursor: "pointer",
                        }}
                    />
                </label>
                <input
                    id={"newfile" + props.userid}
                    ref={inputImageRef}
                    multiple
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={OpenPhotoModal}
                />
            </div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={openPhotoModal}
                onClose={ClosePhotoModal}
                style={{
                    position: "relative",
                    width: "150px",
                    marginTop: "10vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: "1 1 auto",
                        backgroundColor: "var(--modal-bg)",
                        marginLeft: "1300px",
                        borderRadius: "5px",
                    }}
                >
                    {!preview && (
                        <>
                            <div
                                style={{
                                    margin: "15px",
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                    textAlign: "center",
                                    color: "var(--white)",
                                }}
                            >
                                {t("プロファイル写真更新")}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: "1 1 auto",
                                }}
                            >
                                <AvatarEditor
                                    ref={imageRef}
                                    image={profileImage}
                                    width={250}
                                    height={250}
                                    border={50}
                                    color={[255, 255, 255, 0.6]}
                                    scale={scale}
                                    // crossOrigin='anonymous'
                                />
                                <input
                                    name="scale"
                                    type="range"
                                    onChange={handleScale}
                                    color="secondary"
                                    min="1"
                                    max="2"
                                    step="0.01"
                                    defaultValue="1.50"
                                    style={{ margin: "15px" }}
                                />
                                <Button
                                    size="small"
                                    variant="outlined"
                                    style={{
                                        marginTop: "15px",
                                        marginLeft: "22%",
                                        marginBottom: "15px",
                                        backgroundColor: "var(--studio-btn-bg)",
                                        color: "var(--white)",
                                        fontFamily: "noto-sans-cjk-jp",
                                        width: "200px",
                                        height: "40px",
                                    }}
                                    onClick={onClickPreview}
                                >
                                    {t("変更")}
                                </Button>
                            </div>
                        </>
                    )}
                    {preview && (
                        <div
                            style={{
                                width: "500px",
                                display: "flex",
                                flexDirection: "column",
                                flex: "1 1 auto",
                                position: "relative",
                            }}
                        >
                            <Avatar
                                src={newImageUrl}
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    position: "relative",
                                    left: "46%",
                                    marginTop: "15px",
                                    marginBottom: "25px",
                                    backgroundColor: "var(--white)",
                                }}
                            ></Avatar>
                            <span
                                style={{
                                    textAlign: "center",
                                    color: "var(--white)",
                                    fontFamily: "noto-sans-cjk-jp",
                                }}
                            >
                                {t("プロファイル写真を変更しますか？")}
                            </span>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                }}
                            >
                                <Button
                                    size="small"
                                    variant="outlined"
                                    style={{
                                        marginTop: "15px",
                                        marginBottom: "40px",
                                        color: "#9C9C9C",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        border: "solid 2px #5D5D5D",
                                        width: "200px",
                                        height: "40px",
                                    }}
                                    onClick={onClickCancel}
                                >
                                    {t("キャンセル")}
                                </Button>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    disabled={isLoadPreviewImage}
                                    style={{
                                        marginTop: "15px",
                                        marginLeft: "5%",
                                        marginBottom: "40px",
                                        backgroundColor: "var(--studio-btn-bg)",
                                        color: "var(--white)",
                                        fontFamily: "noto-sans-cjk-jp",
                                        width: "200px",
                                        height: "40px",
                                    }}
                                    onClick={onClickSave}
                                >
                                    {t("変更")}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>

            <PuiMessage
                open={isErrorInputSize}
                type="error"
                title={t("正しく選択してください")}
                duration={5000}
                onClose={CloseErrorInputBar}
            />
        </>
    );
}
